module.exports = __webpack_public_path__ + "fonts/Vazir-Meduim-FD.58faaff.woff";